var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canSignInWithApple)?_c('cs-button',{key:"apple",staticClass:"sign-in-with-apple",attrs:{"corners":"rounded"},on:{"click":_vm.loginApple}},[_c('img',{attrs:{"src":_vm.appleLogo}}),_vm._v(" Sign in with Apple")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }